import React, { useState } from 'react'
import './styles/LoginRegister.css'
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useModal } from '../contexts/ModalContext';
import { auth } from '../firebase/config';
import { Oval } from 'react-loader-spinner';
import logo from '../assets/newro-beige-logo.svg'

export default function ForgotPassword({ handleClose }) {
    const { openModal } = useModal();

    const [email, setEmail] = useState("")
    const [isloading, setisloading] = useState(false);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            forgotPasswordCall()
        }
    }

    function navTo(whereTo) {
        handleClose()
        openModal(whereTo)
    }

    async function forgotPasswordCall() {
        try {
            setisloading(true);
            await sendPasswordResetEmail(auth, email.trim());
            openModal("alert", {
                alertProps: { type: 2, message: "Password reset email sent!" },
            });
        } catch (error) {
            openModal("alert", {
                alertProps: { type: 0, message: error.message },
            });
        }
        setisloading(false);
    };

    return (
        <div className='backdrop' onClick={handleClose}>
            <div className='forgot-modal-body' onClick={(e) => e.stopPropagation()} >
                <div className='login-top'>
                    <button className='back-button' style={{ backgroundColor: 'transparent' }} onClick={() => navTo('login')}>
                        <ArrowBackIosIcon sx={{ color: 'white', fontSize: '21px' }} />
                    </button>
                    <div class="company-branding">
                        <div class="company-logo">
                            <img src={logo} />
                        </div>
                        <span class="company-name">newro</span>
                    </div>
                    <button className='close-button' style={{ backgroundColor: 'transparent' }} onClick={handleClose}>
                        <CloseIcon sx={{ color: 'white', fontSize: '27px' }} />
                    </button>
                </div>
                {/* The form */}
                <div className="forgot-inputs">
                    <h3 style={{ color: 'black', margin: 0 }}>Forgot password</h3>
                    <p style={{ color: 'gray', fontSize: '14px', margin: '0' }}>
                        Please enter your email to reset your password.
                    </p>
                    <div className="login-email">
                        <input
                            onKeyDown={(e) => handleKeyPress(e)}
                            className="email-input"
                            type="text"
                            placeholder="Enter your email"
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>
                    <button onClick={() => forgotPasswordCall()} className="login-btn" style={{ marginBottom: '21px' }}>
                        {isloading ? (
                            <Oval
                                visible={true}
                                height="30"
                                width="30"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        ) : (
                            "Reset Password"
                        )}
                    </button>
                </div>
            </div>
        </div >
    )
}
